<template>
  <v-list-item class="history-item">
    <div class="history-item__date">{{ event.created | dateFilter }}</div>

    <div class="history-item__content">
      <div class="v-card-h2">{{ event.benefit.name }}</div>

      <div class="v-card-h4 mt-1" />

      <ul class="tags-container flex-row mt-2 mb-2 px-0">
        <li class="tag">
          <v-icon class="mr-4">storefront</v-icon>

          <router-link :to="{ path: `/partners/${event.place.partner.id}` }">
            {{ event.place.partner.name }}
          </router-link>
        </li>

        <li class="tag">
          <v-icon class="mr-4">mdi-map-marker-outline</v-icon>

          <p>{{ event.place | address }}</p>
        </li>

        <li v-if="event.value || event.benefit.value" class="tag">
          <v-icon class="mr-4">{{ event.benefit.type | benefitIconType }}</v-icon>

          <p>
            {{ event.benefit.type | benefitType }}:
            <span>{{ eventBenefit | benefitValue }}</span>
          </p>
        </li>
      </ul>
    </div>
  </v-list-item>
</template>

<script>
import { address, benefitIconType, benefitType, benefitValue, dateFilter } from '@witkac/kartamiejska-shared';

/**
 * @vuese
 * Pojedynczy rekord historii wykorzystanych usług
 * @group History
 */
export default {
  filters: {
    address,
    benefitIconType,
    benefitType,
    benefitValue,
    dateFilter
  },
  props: {
    // zdarzenie użycia
    event: {
      type: Object,
      required: true
    }
  },
  computed: {
    eventBenefit() {
      const eventBenefit = { ...this.event, type: this.event.benefit.type };
      if (!this.event.value) {
        eventBenefit.value = this.event.benefit.value;
      }
      return eventBenefit;
    }
  }
};
</script>
